import i18next from 'i18next';
import { DEFAULT_LANGUAGE } from '../utils';
import { FeedSource, FEED_SOURCE } from '../../types/enums';
import { translateFTBMarket } from './ftbStrategy';
import { translateOMMarket } from './omStrategy';

export const getMarketTranslationStrategy = (feedSource?: FeedSource) => {
  switch (feedSource) {
    case FEED_SOURCE.FEED_THE_BET:
      return translateFTBMarket;
    case FEED_SOURCE.ODDS_MATRIX:
      return translateOMMarket;
    default:
      return translateFTBMarket;
  }
};

export const shouldLocalize = () => {
  const language = i18next.language;
  return language !== DEFAULT_LANGUAGE;
};

export const getCurrentLanguage = () => {
  return i18next.language ?? DEFAULT_LANGUAGE;
};

export const matchesKey = (text: string | undefined, key: string | undefined) => {
  return key ? text?.split(/[\s\W]+/).includes(key) ?? false : false;
};
